module.exports = __webpack_public_path__ + "img/slide02section03.51a376f9.png";